import { ArrowUp } from "lucide-react";
import { LANDING } from "@/constants/testIds";
import { scrollToTop } from "@/lib/scroll";

export const Footer = () => {
    return (
        <footer className="bg-[#091524] text-white">
            <div className="max-w-7xl mx-auto px-6 md:px-12 lg:px-16 py-16 md:py-20">
                <div className="grid grid-cols-1 md:grid-cols-12 gap-10">
                    <div className="md:col-span-5">
                        <div className="inline-block bg-white rounded-sm p-3">
                            <img
                                src="https://customer-assets.emergentagent.com/job_data-safety-vault/artifacts/wmvlaiol_Apex%20Pro%20Logo%20-%20White.JPG"
                                alt="Apex Pro"
                                className="h-12 w-auto object-contain"
                            />
                        </div>
                        <p className="mt-6 text-white/60 max-w-md">
                            Apex Pro is a safety reporting platform built for high-risk industries.
                            Designed by industry professionals for industry professionals &mdash;
                            streamlining safety reporting, assurance, audits and corrective action
                            tracking.
                        </p>
                    </div>

                    <div className="md:col-span-2">
                        <div className="label-eyebrow text-white/40 mb-4">Product</div>
                        <ul className="space-y-3 text-white/80 text-sm">
                            <li><a href="#features" className="hover:text-[#0052CC]">Features</a></li>
                            <li><a href="#pricing" className="hover:text-[#0052CC]">Pricing</a></li>
                            <li><a href="#faq" className="hover:text-[#0052CC]">FAQ</a></li>
                        </ul>
                    </div>

                    <div className="md:col-span-2">
                        <div className="label-eyebrow text-white/40 mb-4">Company</div>
                        <ul className="space-y-3 text-white/80 text-sm">
                            <li><a href="#" className="hover:text-[#0052CC]">About</a></li>
                            <li><a href="#contact" className="hover:text-[#0052CC]">Contact</a></li>
                            <li><a href="#" className="hover:text-[#0052CC]">Careers</a></li>
                        </ul>
                    </div>

                    <div className="md:col-span-3">
                        <div className="label-eyebrow text-white/40 mb-4">Contact</div>
                        <ul className="space-y-3 text-white/80 text-sm">
                            <li>
                                <a
                                    href="mailto:info@apexprosafety.com"
                                    className="hover:text-[#0052CC] transition"
                                >
                                    info@apexprosafety.com
                                </a>
                            </li>
                            <li className="text-white/60 leading-relaxed">
                                Office No: CWS-2V-227744, 26th Floor<br />
                                Amber Gem Tower, Sheikh Khalifa Street<br />
                                Ajman, United Arab Emirates<br />
                                P.O. Box 4848
                            </li>
                        </ul>
                    </div>
                </div>

                <div className="mt-16 pt-8 border-t border-white/10 flex flex-col md:flex-row items-start md:items-center justify-between gap-6">
                    <div className="text-xs text-white/50">
                        © {new Date().getFullYear()} Apex Pro. All rights reserved.
                    </div>
                    <div className="flex items-center gap-4 md:gap-6">
                        {/* Trust badges — bottom right */}
                        <div className="flex items-center gap-3">
                            <div
                                data-testid="trust-badge-aws"
                                className="bg-white rounded-sm p-1.5 flex items-center justify-center"
                            >
                                <img
                                    src="https://customer-assets-jai6qajn.emergentagent.net/job_data-safety-vault/artifacts/cqjbf2cn_image.png"
                                    alt="AWS Partner"
                                    className="h-12 w-auto object-contain"
                                />
                            </div>
                            <div
                                data-testid="trust-badge-namaka"
                                className="bg-white rounded-sm p-1.5 flex items-center justify-center"
                            >
                                <img
                                    src="https://customer-assets-jai6qajn.emergentagent.net/job_data-safety-vault/artifacts/ulkfwa5z_image.png"
                                    alt="Namaka Subsea"
                                    className="h-12 w-auto object-contain"
                                />
                            </div>
                        </div>
                        <button
                            data-testid={LANDING.footerBackToTop}
                            onClick={scrollToTop}
                            className="inline-flex items-center gap-1.5 text-xs text-white hover:text-[#0052CC] transition"
                        >
                            Back to top <ArrowUp size={12} />
                        </button>
                    </div>
                </div>
            </div>
        </footer>
    );
};
